import { gql } from "@apollo/client";
import { InvoiceStatus, ShopSyncEntityType, ShopSyncStatusEnum } from "TypesAndInterfaces";

//#region Types & Enums

export type InvoiceLogsFilter = {
  shopId?: number;
  invoiceId?: number;
  status?: InvoiceStatus;
  fromDate?: Date;
  toDate?: Date;
  isAscending?: boolean;
};

export type ShopLogsFilter = {
  shopId?: number;
  status?: ShopSyncStatusEnum;
  fromDate?: Date;
  toDate?: Date;
  isAscending?: boolean;
};

export type LogOutput = {
  date: Date;
  status: string;
  reason?: string;
  marketplaceName: string;
  shopId: number;
  invoiceId?: number;
  invocationId?: number;
  emailSent?: boolean;
  emailTextContent?: string;
  type?: ShopSyncEntityType;
  requestId?: string;
  retryCount?: number;
  channelCode: string;
};

//#endregion

//#region Queries

export const GET_INVOICE_LOGS = gql`
  query GetInvoiceLogs(
    $marketplaceId: Float!
    $filter: InvoiceLogsFilter
    $pagination: PaginationInfo
  ) {
    getInvoiceLogs(
      marketplaceId: $marketplaceId
      filter: $filter
      pagination: $pagination
    ) {
      logs {
        date
        retryCount
        invoiceId
        marketplaceName
        reason
        shopId
        status
        requestId
        type
        invocationId
        emailSent
        emailTextContent
        channelCode
      }
    }
  }
`;

export const GET_SHOP_LOGS = gql`
  query GetShopLogs(
    $marketplaceId: Float!
    $filter: ShopLogsFilter
    $pagination: PaginationInfo
  ) {
    getShopLogs(
      marketplaceId: $marketplaceId
      filter: $filter
      pagination: $pagination
    ) {
      logs {
        date
        invoiceId
        marketplaceName
        reason
        shopId
        status
        type
        invocationId
        emailSent
        emailTextContent
        channelCode
      }
    }
  }
`;

export const GET_OLD_INVOICE_LOGS = gql`
  query GetOldInvoiceLogs(
    $marketplaceId: Float!
    $filter: InvoiceLogsFilter
    $pagination: PaginationInfo
  ) {
    getOldInvoiceLogs(
      marketplaceId: $marketplaceId
      filter: $filter
      pagination: $pagination
    ) {
      logs {
        date
        retryCount
        invoiceId
        marketplaceName
        reason
        shopId
        status
        requestId
        type
        invocationId
        emailSent
        emailTextContent
        channelCode
      }
      total
    }
  }
`;

export const GET_OLD_SHOP_LOGS = gql`
  query GetOldShopLogs(
    $marketplaceId: Float!
    $filter: ShopLogsFilter
    $pagination: PaginationInfo
  ) {
    getOldShopLogs(
      marketplaceId: $marketplaceId
      filter: $filter
      pagination: $pagination
    ) {
      logs {
        date
        invoiceId
        marketplaceName
        reason
        shopId
        status
        type
        invocationId
        emailSent
        emailTextContent
        channelCode
      }
      total
    }
  }
`;

//#endregion
